import React from 'react';

import { FlexLink } from '../../shared';

const Banner = ({ contentText, link, linkText }) => {
  return (
    <div className="Banner">
      <span className="content track-click">
        <p>{contentText}</p>
      </span>
      {link && (
        <FlexLink href={link} className="button banner-button">
          {linkText}
        </FlexLink>
      )}
    </div>
  );
};

export default Banner;
